import { checkImageInError } from '../utils/utils.js';

const btnApercuPrevious = document.querySelector(
  'button.dossier-illustrations-apercu-button.previous',
);
const btnApercuNext = document.querySelector(
  'button.dossier-illustrations-apercu-button.next',
);

btnApercuPrevious?.addEventListener('click', function () {
  const previousImage = getCurrentImage().previousElementSibling;
  doRemplacement(previousImage);
  checkButtons();
});

btnApercuNext?.addEventListener('click', function () {
  const nextImage = getCurrentImage().nextElementSibling;
  doRemplacement(nextImage);
  checkButtons();
});

// sur le clic d'une image, on change l'image dans l'aperçu
document
  .querySelectorAll('.dossier-illustrations-mosaique .image-container')
  .forEach(function (element) {
    element.addEventListener('click', function () {
      const image = this;
      doRemplacement(image);
      checkButtons();
    });
  });

document
  .querySelectorAll(
    '.dossier-illustrations-mosaique img, .dossier-illustrations-apercu img',
  )
  .forEach((vignette) => checkImageInError(vignette, '.image-container'));

function doRemplacement(image) {
  const currentImage = getCurrentImage();
  currentImage.classList.remove('current');
  image.classList.add('current');
  image.scrollIntoViewIfNeeded();

  const oldImageContainer = findRelatedImageContainer(currentImage);
  const newImageContainer = findRelatedImageContainer(image);

  toggleImage(oldImageContainer, false);
  toggleImage(newImageContainer, true);
}

function checkButtons() {
  const currentImage = getCurrentImage();
  btnApercuNext.disabled = currentImage.nextElementSibling == null;
  btnApercuPrevious.disabled = currentImage.previousElementSibling == null;
}

function getCurrentImage() {
  return document.querySelector('.dossier-illustrations-mosaique div.current');
}

function findRelatedImageContainer(imageContainer) {
  return ['illustration', 'carte']
    .map((type) => {
      const currentId = imageContainer.getAttribute(`data-${type}-id`);
      return document.querySelector(
        `.dossier-illustrations-apercu .image-container[data-${type}-id="${currentId}"]`,
      );
    })
    .find((imageContainer) => !!imageContainer).parentElement;
}

function toggleImage(image, visible) {
  image.classList.toggle('apercu', visible);
  image.classList.toggle('apercu-hidden', !visible);
}
